var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeaks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 428L113 360L225 405L338 415L450 399L563 437L675 376L788 439L900 373L900 601L788 601L675 601L563 601L450 601L338 601L225 601L113 601L0 601Z",
    fill: "#00527c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 406L113 469L225 395L338 476L450 449L563 428L675 438L788 461L900 456L900 601L788 601L675 601L563 601L450 601L338 601L225 601L113 601L0 601Z",
    fill: "#076b97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 480L113 437L225 475L338 496L450 500L563 471L675 487L788 445L900 460L900 601L788 601L675 601L563 601L450 601L338 601L225 601L113 601L0 601Z",
    fill: "#1286b1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 518L113 505L225 519L338 494L450 540L563 530L675 481L788 481L900 525L900 601L788 601L675 601L563 601L450 601L338 601L225 601L113 601L0 601Z",
    fill: "#1fa2cb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 526L113 559L225 534L338 539L450 554L563 558L675 570L788 551L900 536L900 601L788 601L675 601L563 601L450 601L338 601L225 601L113 601L0 601Z",
    fill: "#2ebee4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaks);
export default __webpack_public_path__ + "static/media/peaks.77e855b5020b03725f98e50da51b91bc.svg";
export { ForwardRef as ReactComponent };